import React from 'react';

const ChapterDetailCard = ({ name, logo, group, description, chapterExecutive, programsExecutive, established, contactEmail, stats }) => (
  <div>
    <h1 className="huge-title">
      Chapter Overview
    </h1>
    <div style={{
      background: '#0F0F1A',
      color: '#ffffff',
      borderRadius: '0.75rem',
      maxWidth: '600px',
      border: '1px solid rgba(99, 102, 241, 0.25)',
      boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
      display: 'flex',
      flexDirection: 'column',
      gap: '1rem',
    }}>
      <img
          src={`${group}`}
          alt={`${name} group photo`}
          style={{
            width: '100%',
            maxWidth: '900px',
            borderRadius: '1rem',
            border: '1px solid rgba(255,255,255,0.1)',
            objectFit: 'cover',
            borderBottomLeftRadius: '0',
            borderBottomRightRadius: '0',
          }}
        />
      <div style={{ padding: '1rem' }}>
        <div className="big-content-text">
          <p><strong>Chapter Executive:</strong> {chapterExecutive}</p>
          <p><strong>Programs Executive:</strong> {programsExecutive}</p>
          <p><strong>Established:</strong> {established}</p>
          <p><strong>Active Projects:</strong> {stats?.activeProjects}</p>
          <p><strong>Members:</strong> {stats?.members}</p>
          <p><strong>Contact:</strong> <a href={`mailto:${contactEmail}`} className='link-text' >{contactEmail} ↗</a></p>
        </div>
      </div>
    </div>
  </div>
);

export default ChapterDetailCard;
